export default function collectRouteParams(p = {}) {

    const {
        startRoutes = [{ path: '/', contentName: 'post' }],
        params = ['/page/:pagination', '/sort/:sort', '/limit/:limit', '/tags/:tags'],
        flexibleParams = false
    } = p

    if (flexibleParams) {
        // Generate combinations (order doesn't matter) instead of permutations
        // With N params: 2^N - 1 routes instead of sum of P(N,k)
        const combinations = []
        const total = 1 << params.length // 2^N
        for (let mask = 1; mask < total; mask++) {
            const combo = []
            for (let i = 0; i < params.length; i++) {
                if (mask & (1 << i)) {
                    combo.push(params[i])
                }
            }
            combinations.push(combo.join(''))
        }

        // Sort by number of params (shorter first) to preserve match priority
        combinations.sort(function(a, b) {
            return a.split('/').length - b.split('/').length
        })

        return startRoutes.reduce((a, { path, contentName }) => {
            a.push(
                { path, contentName },
                ...combinations.map((parts) => ({
                    path: path + parts.replace('//', '/'),
                    contentName,
                    flexibleParams: true
                }))
            )
            return a
        }, [])
    }

    // Original permutation-based logic
    const getPermutations = function(list, maxLen) {
        const perm = list.map(function(val) {
            return [val]
        })
        const generate = function(perm, maxLen, currLen) {
            if (currLen === maxLen) {
                return perm
            }
            for (let i = 0, len = perm.length; i < len; i++) {
                const currPerm = perm.shift()
                for (let k = 0; k < list.length; k++) {
                    if (currPerm.indexOf(list[k]) === -1) {
                        perm.push(currPerm.concat(list[k]))
                    }
                }
            }
            return generate(perm, maxLen, currLen + 1)
        }
        return generate(perm, maxLen, 1)
    }

    const r = []

    params.forEach((v, i) => {
        r.push(...getPermutations(params, i + 1).map((parts) => parts.join('')))
    })

    return startRoutes.reduce((a, { path, contentName }) => {
        a.push(
            { path, contentName },
            ...r.map((parts) => ({ path: path + parts.replace('//', '/'), contentName }))
        )
        return a
    }, [])

}
